// components
import { Form, InputGroup, FormControlProps, Uploader, Button } from 'rsuite';
// styles
import style from './ExInputUploader.module.css';

type Props = Omit<FormControlProps, 'name'> & {
    name: string;
    type: string;
    label: string;
    value: string;
    error: string | number | null;
    startIcon: string | JSX.Element;
    accept: string;
    onChange: (obj: any) => void;
    isRequired: boolean;
    showErrorIcon?: boolean;
    showOptionalLabel?: boolean;
    maxWidth?: boolean;
};

const ExInputUploader = ({
    name,
    type,
    label,
    accepter,
    error,
    isRequired,
    maxWidth,
    value,
    showErrorIcon,
    showOptionalLabel,
    startIcon,
    accept,
    onChange,
    ...rest
}: Props) => {
    return (
        <Form.Group className={style['form-input-group']} controlId={`form-input-${name}`}>
            <Form.ControlLabel htmlFor={`form-input-${name}`}>
                <span className={style['form-input-label']}>{label}</span>
                {isRequired && <span className={style['form-input-required']}>*</span>}
                {!isRequired && showOptionalLabel && <span className={style['form-input-optional']}>(opcional)</span>}
            </Form.ControlLabel>
            <InputGroup
                style={{ width: maxWidth ? '100%' : 'unset' }}
                className={error ? style['form-input-error'] : style['form-input-container']}
            >
                <InputGroup.Addon
                    style={{
                        background: 'none',
                        paddingRight: 0,
                    }}
                >
                    {startIcon}
                </InputGroup.Addon>
                <Form.Control
                    id={`form-input-${name}`}
                    name={name}
                    type={type}
                    accepter={accepter}
                    errorMessage={null}
                    className={style['form-input']}
                    value={value}
                    {...rest}
                />
                <InputGroup.Addon style={{ padding: 0 }}>
                    <Uploader
                        className={style['uploader']}
                        accept={accept}
                        fileListVisible={false}
                        action=""
                        onChange={onChange}
                    >
                        <Button>Subir archivo</Button>
                    </Uploader>
                </InputGroup.Addon>
            </InputGroup>
            <div className={style['message-container']}>
                <span className={style['form-error-message']}>
                    {showErrorIcon && <img src="/assets/images/error.svg" alt="icon error" width={16} height={16} />}
                    {error}
                </span>
            </div>
        </Form.Group>
    );
};

export default ExInputUploader;
